export default __webpack_public_path__ + "static/media/StarsYellow.1822cc2b.svg";